import React, { useState, useEffect } from 'react';
import { Modal, Table } from 'react-bootstrap';
import axios from 'axios';
import config from '../Common_Files/Config';
import { Link } from 'react-router-dom';

const ProductBatch = ({ onViewPastPurchase, getProductBatchData, modalData = false, onBatchModalClose }) => {
  const [productBatch, setProductBatch] = useState([]);
  const [productPO, setProductPO] = useState([]);
  const [showPastPurchaseModal, setShowPastPurchaseModal] = useState(false);
  const [showInvoiceModal, setShowInvoiceModal] = useState(false);
  const [selectedInvoice, setSelectedInvoice] = useState(null);

  const accessToken = localStorage.getItem('accessToken');

  const handleShowPastPurchaseModal = () => setShowPastPurchaseModal(true);
  
  const handleClosePastPurchaseModal = () => {
    setShowPastPurchaseModal(false);
    // Notify parent component that batch modal is closed
    if (onBatchModalClose) {
      onBatchModalClose();
    }
  };

  const handleShowInvoiceModal = (event) => {
    event.preventDefault();

    const productId = event.currentTarget.getAttribute('data-id');
    setSelectedInvoice(productId);
    setShowInvoiceModal(true);
    GetProductPO(productId);
  };

  const handleCloseInvoiceModal = () => setShowInvoiceModal(false);

  const GetProductPO = async (id) => {
    try {
      const formData = new FormData();
      formData.set('product_id', id);

      const response = await axios.post(
        `${config.api_url}/ws-get-product-po`,
        formData,
        {
          headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      setProductPO(response.data.purchase);
    } catch (error) {
      console.error("Error fetching product PO data:", error);
    }
  };

  // Function to determine if data is batch data
  const isBatchData = (data) => {
    if (!data || !Array.isArray(data) || data.length === 0) return false;
    const firstItem = data[0];
    // Batch data typically has reference_no and different structure than product data
    return firstItem && 
           (firstItem.reference_no || firstItem.qty !== undefined || firstItem.net_price !== undefined);
  };

  useEffect(() => {
    if (modalData && isBatchData(modalData)) {
      console.log('ProductBatch: Setting batch data:', modalData);
      setProductBatch(modalData);
    }
  }, [modalData]);

  useEffect(() => {
    if (onViewPastPurchase) {
      onViewPastPurchase(handleShowPastPurchaseModal);
    }
  }, [onViewPastPurchase]);

  return (
    <div>
      <Modal show={showPastPurchaseModal} onHide={handleClosePastPurchaseModal} size="lg">
        <Modal.Header closeButton>
          <h5>All Batches: {productBatch[0]?.product_desc}  ({productBatch[0]?.code})</h5>
        </Modal.Header>
        <Modal.Body>
          <div className="partialbox">
            <h3>
              <a href="#" data-id={productBatch[0]?.product_id} onClick={handleShowInvoiceModal}>
                View Past Purchase
              </a>
            </h3>

            <Table striped bordered hover className="dataTable">
              <thead>
                <tr>
                  <th>Purchase Qty</th>
                  <th>Sold Qty</th>
                  <th>Bal Qty</th>
                  <th>Alloc</th>
                  <th>UnAlloc</th>
                  <th>PO No.</th>
                  <th>Net Price</th>
                  {/* <th>Received</th> */}
                </tr>
              </thead>
              <tbody>
                {productBatch.map((item, index) => (
                  <tr key={`batch-${item.id || index}`}>
                    <td>{item.qty}</td>
                    <td>{item.sale_qty}</td>
                    <td>{item.qty - item.sale_qty}</td>
                    <td>{item.allocation}</td>
                    <td>{item.qty - item.allocation}</td>
                    <td>
                      <a href={`/editNewPurchaseOrder/${item.purchase_id}`}>
                        {item.reference_no}
                      </a>
                    </td>
                    <td>{Number(item.net_price || 0).toFixed(2)}</td>
                     {/* <td>{item.received_qty}</td> */}
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </Modal.Body>
        <Modal.Footer>
          {/* Add footer content if needed */}
        </Modal.Footer>
      </Modal>

      <Modal
        show={showInvoiceModal}
        onHide={handleCloseInvoiceModal}
        size="lg"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <h5>Past Purchase History: {productBatch[0]?.product_desc}  ({productBatch[0]?.code})</h5>
        </Modal.Header>
        <Modal.Body>
          <div className="partialbox">
            <Table striped bordered hover className="dataTable">
              <thead>
                <tr>
                  <th>PO#</th>
                  <th>Qty</th>
                  <th>Cost Price</th>
                  <th>Net Price</th>
                  <th>Discount</th>
                  <th>Delivered on</th>
                </tr>
              </thead>
              <tbody>
                {productPO.map((item, index) => (
                  <tr key={`po-${item.id || index}`}>
                    <td>{item.reference_no}</td>
                    <td>{item.quantity}</td>
                    <td>{item.cost}</td>
                    <td>{Number(item.net_price || 0).toFixed(2)}</td>
                    <td>{item.discount_amount}</td>
                    <td>{item.arrival_date}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </Modal.Body>
        <Modal.Footer>
          {/* Add footer content if needed */}
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ProductBatch;
